import React, { useEffect, useState } from 'react';
import "./style.sass";
import HeaderMobileCredito from 'components/Header/HeaderMobileCredito';
import { CopyToClipboard } from 'react-copy-to-clipboard';
import { useHistory } from 'react-router-dom';
import { BASE_PATH, SUB_DIRECTORY } from 'constants/general';
import { decodeStorage } from 'functions/storageBase64';

export function SolicitudFinalizadaMobile({ cancelar, numFolio }) {

    const [folio, setFolio] = useState("123456789");
    const [, setcopied] = useState(false);
    const [click, setclick] = useState(false);
    const EXTERNO = decodeStorage('EXTERNO');

    const onCopy = () => { setcopied(true); }

    const handleClickCopy = () => {
        setclick(!click);
    }

    const history = useHistory();

    /* const handleIrHome = () => {
        history.push(`${BASE_PATH}${SUB_DIRECTORY}home`);
    }; */

    const handleIrClaroScore = () => {
        history.push(`${BASE_PATH}${SUB_DIRECTORY}validacion-antes/0`);
    };

    useEffect(() => {
        if (numFolio) {
            setFolio(numFolio.folio);
        }
    }, [numFolio])

    return (
        <>
            <div className="modalCredito full">
                <div className="contentModal">
                {
                    EXTERNO ? null : <HeaderMobileCredito logo="img/logo-claroshop.png" type="close" goBack={"claroScore"}/>
                }
                    <div className="contenedorGeneral">
                        <div className="sFmobile">
                            <img src="img/paloma_aprobado.svg"></img>
                            <h2 className="tituloFin colorVerde">¡Tu solicitud ha sido enviada con éxito!</h2>

                            <p className="copyNormal">Te enviaremos un correo con el estatus de tu solicitud</p>

                            <div className='capturaP'>
                                <img src="/credito-claroshop/img/icon_captura_pantalla.svg"></img>
                                <span className='fontgris'>Captura esta pantalla o anota tu número de folio</span>
                            </div>


                            <p className="folio marginTop15">Folio de solicitud</p>

                            <div className="divFolio">
                                <CopyToClipboard text={folio} onCopy={() => setcopied(true)}>
                                    <>
                                        <span className="boldFolio">#{folio}</span>
                                    </>
                                </CopyToClipboard>

                                <CopyToClipboard text={folio} onCopy={() => onCopy()}>
                                    <button onClick={handleClickCopy} className="botonCopy" />
                                </CopyToClipboard>
                            </div>

                        </div>
                    </div>
                </div>
            </div>
            <div className="boxBtnSolicitar">
                <button className="btnSolicitar" onClick={handleIrClaroScore}>Enterado</button>
            </div>
        </>
    )
}